import * as Utils from "@/utils";
namespace Constants {
  export const LOGGER_DEV = window.localStorage.getItem("LOGGER_DEV") === "1";

  /** 是否为开发环境 */
  export const IS_DEV = import.meta.env.MODE === "dev";

  /** 是否为开发/测试环境 */
  export const IS_DEBUG = import.meta.env.MODE !== "production";

  /** 是否使用debug模式；使用时会打开vconsole */
  export const IS_USEDEBUG = Utils.getDebugFlag() === "1";

  export const enum ETabKey {
    // 客户端
    CLIENT_APP = "CLIENT_APP",
    // 开播端
    LIVE_APP = "LIVE_APP",
  }

  export const TAB_LIST = [
    { key: ETabKey.CLIENT_APP, label: "虎牙直播客户端" },
    { key: ETabKey.LIVE_APP, label: "开播工具" },
  ];

  export const NAV_TAGS = {
    [ETabKey.CLIENT_APP]: ["pc", "android", "iphone", "pad", "ipad", "mac", "tv", "pc_express"],
    [ETabKey.LIVE_APP]: ["players_pc", "players_phone"],
  };
  export const DOWNLOAD_URL = {
    PC_WIN: "https://download.huya.com/huya_pc_w_package/HuyaMiniLoader.exe",
    PC_WIN_ARM: "https://download.huya.com/huyapc/install/HuyaClientInstall73000120.exe",
    PC_MAC:
      "https://apps.apple.com/cn/app/%E8%99%8E%E7%89%99%E7%9B%B4%E6%92%ADhd-%E6%B8%B8%E6%88%8F%E4%BA%92%E5%8A%A8%E7%9B%B4%E6%92%AD%E5%B9%B3%E5%8F%B0/id886103288",
    PC_MAC_DMG: "https://rel.huya.com/huyamac",
    APP_IOS: "https://itunes.apple.com/cn/app/wei/id871095743",
    APP_ADR: "https://rel.huya.com/apk/live.apk",
    TV: "https://rel.huya.com/apk/tv?key=tv0001",
    // 三角洲地图工具
    DELTA_MAP_TOOL: "https://download.huya.com/huya_pc_w_package/HuyaMiniLoader.ZGZtYXA.exe",
    // PC极速版
    PC_EXPRESS: "https://download.huya.com/huyapc/install/HuyaMiniClient.exe",
    // 奶瓶加速器
    NAIPING_ACCELERATOR:
      "https://loong.cdn.huya.com/np_booster_app/win-downloader/NPDownloader.exe",
    LIVE_PC: "https://download.huya.com/huyapc/install/HuyaClientAnchorInstall.exe",
    ZS_IOS: "https://rel.huya.com/apk/zs?key=zsios",
    ZS_ADR: "https://rel.huya.com/apk/zs?key=zsandroid",
  };
}

export default Constants;
